import AircraftAbout from './AircraftAbout';
export default AircraftAbout;
